import React from 'react';
import './Food.css';



const FoodDetail = ({ item, onClose }) => (
  <div className="food-card">
    <button className="close-btn" onClick={onClose}>✖</button>
    <h2 className="food-name">{item.name}</h2>
    <img src={item.image} />
   

    

    <div className="food-info-grid">
      <div className="food-info-item">
        <span className="label">flavorProfile</span>
        <span className="value">{item.flavorProfile}</span>
      </div>
      <div className="food-info-item">
        <span className="label">GI</span>
        <span className="value">{item.gi}</span>
      </div>
      <div className="food-info-item">
        <span className="label">Origin</span>
        <span className="value">{item.origin}</span>
      </div>
      <div className="food-info-item">
        <span className="label">calories Per 100gms</span>
        <span className="value">{item.caloriesPer100gms}</span>
      </div>
       <div className="food-info-item">
        <span className="label">Not Good For Individuals(consult doctor)</span>
        <span className="value">{item.notGoodForPatients}</span>
      </div>
      <div className="food-info-item">
        <span className="label">signature Dishes</span>
        <span className="value">{item.signatureDishes}</span>
      </div>
      <div className="food-info-item">
        <span className="label">Facts</span>
        <span className="value">{item.facts}</span>
      </div>
      <div className="food-info-item">
        <span className="label">Nutrition</span>
        <span className="value">{item.nutrition}</span>
      </div>
      <div className="food-info-item">
        <span className="label">Good for Individuals (Consult doctor)</span>
        <span className="value">{item.goodForPatients}</span>
      </div>
      <div className="food-info-item">
        <span className="label">uses</span>
        <span className="value">{item.uses}</span>
      </div>
      <div className="food-info-item">
        <span className="label">Health Benefits</span>
        <span className="value">{item.healthBenefits}</span>
      </div>
        <div className="food-info-item">
        <span className="label">drawbacks</span>
        <span className="value">{item.drawbacks}</span>
      </div>
      <div className="food-info-item">
        <span className="label">History</span>
        <span className="value">{item.history}</span>
      </div>
      <div className="food-info-item">
        <span className="label">Description</span>
        <span className="value">{item.description}</span>
      </div>
    
    <div className="food-info-item">
        <span className="label">Historical Moment</span>
        <span className="value">{item.historical_moment}</span>
      </div>
      <div className="food-info-item">
        <span className="label">Others</span>
        <span className="value">{item.wisdom}</span>
      </div>
<div className="food-info-item">
  <span className="label">Culinary Uses</span>
  <ul className="value">
    {item.culinary_uses.map((use, index) => (
      <li key={index}>{use}</li>
    ))}
  </ul>
</div>

<div className="food-info-item">
  <span className="label">Nutritional Profile (per 100g)</span>
  <ul className="value">
    {Object.entries(item.nutritional_profile_per_100g).map(([key, value]) => (
      <li key={key}>
        <strong>{key}:</strong> {value}
      </li>
    ))}
  </ul>
</div>

<div className="food-info-item">
  <span className="label">Best For</span>
  <ul className="value">
    {item.best_for.map((benefit, index) => (
      <li key={index}>{benefit}</li>
    ))}
  </ul>
</div>

<div className="food-info-item">
  <span className="label">Helpful For</span>
  <ul className="value">
    {item.helpful_for.map((group, index) => (
      <li key={index}>{group}</li>
    ))}
  </ul>
</div>

<div className="food-info-item">
  <span className="label">How It Is Found</span>
  <ul className="value">
    {item.how_it_is_found.map((method, index) => (
      <li key={index}>{method}</li>
    ))}
  </ul>
</div>

<div className="food-info-item">
  <span className="label">Life Span</span>
  <ul className="value">
    {Object.entries(item.life_span).map(([stage, duration]) => (
      <li key={stage}>
        <strong>{stage}:</strong> {duration}
      </li>
    ))}
  </ul>
</div>

<div className="food-info-item">
  <span className="label">What's In It</span>
  <ul className="value">
    {item.whats_in_it.map((compound, index) => (
      <li key={index}>{compound}</li>
    ))}
  </ul>
</div>

<div className="food-info-item">
  <span className="label">How Special Is It</span>
  <ul className="value">
    {item.how_special_is_it.map((note, index) => (
      <li key={index}>{note}</li>
    ))}
  </ul>
</div>


    </div>
  </div>
);

export default FoodDetail;
